module.exports = __webpack_public_path__ + "static/media/swiperBj.8fbd7592.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/images/swiperBj.png
// module id = 95
// module chunks = 0